/// <reference path="Definitions/custom.d.ts" />
/// <reference path="Definitions/google.maps.d.ts" />
/// <reference path="Definitions/underscore.d.ts" />

import * as $ajax from './_ajax'
import * as $flag from './_flag'
import * as $helpers from './_helpers'
import * as $modal from './_modal'
import * as $loading from './_loading'
import * as $types from './_types'

var ownerId: number = 0
var pageName: string = null
var pagePrefix: string = null

export function init($pageName, $pagePrefix, $ownerId): void {
    pageName = $pageName
    pagePrefix = $pagePrefix
    ownerId = $ownerId

    $('.' + pagePrefix + '-ownersonsameaddress .name').click(function (e) {
        console.log('link klick')
        var url = $(this).attr('data-link')
        $modal.load(url, {}, false, true, true)
        e.preventDefault()
    })
}
